import React, { Fragment, useEffect, useMemo, useRef, useState } from "react";
import ReactDatePicker from "react-datepicker";
import { useTranslation } from "react-i18next";
import { NumericFormat } from "react-number-format";
import Select from "react-select";
import { Button } from "../../Components/Button";
import {
  clearAccountingTransaction,
  clearAcctTransactionError,
  clearBusinessPartner,
  clearBusinessPartnerError,
  clearDocumentExcelUploadStatus,
  clearInitAccountStatus,
  clearTermsError,
  clearTermsStatus,
  clearUpdateBusiness,
  requestUpdateBusiness,
  requestAcceptTerms,
  requestCreateAcctTransaction,
  requestCreateBusinessPartner,
  requestCreateBusinessTransaction,
  requestDeleteAcctTransaction,
  requestDocumentExcelAccTransactionUpload,
  requestGetAccountingTransaction,
  requestGetParentAccountingTransaction,
  requestGetTerms,
  requestGetUser,
  requestInitAccount,
  requestListAccount,
  requestListBusiness,
  requestListBusinessPartner,
  requestListCreditAccount,
  requestListDebitAccount,
  requestListTermsAcceptance,
  requestRemoveTermsAcceptance,
  requestUpdateAcctTransaction,
  resetNewBusinessTransaction,
  useAccountingDispatch,
  useAccountingState,
  useAuthDispatch,
  useAuthState,
  useBusinessTransactionDispatch,
  useBusinessTransactionState,
  useTermsDispatch,
  useTermsState,
  usePeriodLock,
} from "../../Context";
import { useLocation, useNavigate } from "react-router-dom";
import { ModalConfirm } from "../../Components/ModalConfirm";
import { Alert } from "../../Components/Alert";
import BusinessStatusBanner from "../../Components/v2/Business/BusinessStatusBanner";
import PeriodLockBanner from "../../Components/v2/Accounting/PeriodLockBanner";
import PeriodClosedNotice from "../../Components/v2/Accounting/PeriodClosedNotice";
import { isBusinessWriteBlocked } from "../../Constants/business";
import { EmptyBusinessSkeleton } from "../../Components/EmptyBusinessSkeleton";
import { TRANSACTION_TYPES } from "../../Constants";
import {
  BUSINESS_CATEGORIES,
  BUSINESS_ENTITY_TYPES,
  BUSINESS_TYPES_OPTIONS,
} from "../../Constants/business";
import { Modal } from "../../Components/Modal";
import {
  cancelAPIRequest,
  classNames,
  convertToTitleCase,
  getAccountingFileName,
  getErrorMessages,
  getPeriodClosedError,
  parseTypedClosedDate,
} from "../../Utils";
import dayjs from "dayjs";
import ErrorStateTable from "../../Components/ErrorStateTable";
import {
  ArrowSmRightIcon,
  ArrowSmUpIcon,
  DocumentIcon,
  PencilAltIcon,
  TrashIcon,
  RefreshIcon,
} from "@heroicons/react/outline";
import { ModalAlert } from "../../Components/ModalAlert";
import FormLabel from "../../Components/FormLabel";
import { Field, Label, Switch } from "@headlessui/react";
import JournalEntryTable from "../../Components/JournalEntryTable";
import EmptyBusiness from "../../Components/EmptyBusiness";
import { downloadData, getUrl } from "aws-amplify/storage";
import { ClipboardListIcon, SparklesIcon } from "@heroicons/react/solid";
import MaintenanceModal from "../../Components/MaintenanceModal";
import Badge from "../../Components/Badge";
import { useRemoteConfig } from "../../Context/firebase/context";
import Markdown from "react-markdown";
import { rawMarkdownRehypePlugins } from "../../Utils/markdownSanitize";
import remarkGfm from "remark-gfm";

const paymentTransactionTypes = ["PAYABLE_PAYMENT", "RECEIVABLE_PAYMENT"];
const receivableTransactionTypes = ["RECEIVABLE", "INCOME_RECEIVABLE"];
const partnerTransactionTypes = [
  "INCOME",
  "EXPENSE",
  "INCOME_RECEIVABLE",
  "EXPENSE_PAYABLE",
  "PAYABLE",
  "RECEIVABLE",
];

const TERMS_ID = "accounting-upload-ai-v1";

export const AccountingTransactionCreate = () => {
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();
  const {
    accounting_import_detection: importDetectionConfig,
    loading: configLoading,
  } = useRemoteConfig();

  const [selectedBusiness, setSelectedBusiness] = useState(null);
  // Optional business-profile completion before seeding the default chart, so
  // the backend shapes accounts from type/structure/category (like OnboardingCOA).
  const [typeSel, setTypeSel] = useState(null);
  const [structureSel, setStructureSel] = useState(null);
  const [categorySel, setCategorySel] = useState(null);
  const [updatingProfile, setUpdatingProfile] = useState(false);
  const [debitAccount, setDebitAccount] = useState(null);
  const [total, settotal] = useState("");
  const [date, setdate] = useState(new Date());
  const [transactionType, settransactionType] = useState(null);
  const [creditAccount, setCreditAccount] = useState();
  const [description, setdescription] = useState();
  const [cashbookSync, setcashbookSync] = useState(false);
  const [accountItems, setaccountItems] = useState([
    {
      account: "",
      debit: { value: "0", floatValue: 0 },
      credit: { value: "0", floatValue: 0 },
    },
  ]);

  const [showSuccessModal, setshowSuccessModal] = useState(false);
  const [showSyncSuccess, setshowSyncSuccess] = useState(false);
  const [showErrorModal, setshowErrorModal] = useState(false);
  const [showConfirmModal, setshowConfirmModal] = useState(false);
  const [showPartnerModal, setshowPartnerModal] = useState(false);
  const [paidTransactionID, setpaidTransactionID] = useState("");
  const [fieldError, setfieldError] = useState(false);
  const [fieldErrorAccount, setfieldErrorAccount] = useState(false);
  const [paid, setpaid] = useState(true);
  const [selectedPartner, setselectedPartner] = useState(null);
  const [dueDate, setdueDate] = useState(null);

  const [inputErrors, setinputErrors] = useState({});
  const [accountItemsError, setaccountItemsError] = useState("");
  const [showPaymentModal, setshowPaymentModal] = useState(false);
  const [selectedAccount, setselectedAccount] = useState(null);
  const [paymentDate, setpaymentDate] = useState(new Date());
  const [totalPaid, settotalPaid] = useState("");
  const [paymentDescription, setpaymentDescription] = useState("");

  const [partnerName, setpartnerName] = useState("");
  const [businessType, setbusinessType] = useState("");
  const [partnerSubmitted, setpartnerSubmitted] = useState(false);

  const [downloading, setdownloading] = useState(false);
  const [downloadProgress, setdownloadProgress] = useState(0);
  const [downloadDocError, setdownloadDocError] = useState(null);
  const [showDownloadErrorModal, setshowDownloadErrorModal] = useState(false);
  const downloadRef = useRef(null);
  const [selectedFile, setselectedFile] = useState("");
  const [fileError, setfileError] = useState(null);
  const [fieldErrorFile, setfieldErrorFile] = useState({
    status: false,
    message: "",
  });
  const [showProgressModal, setShowProgressModal] = useState(false);

  const searchParams = new URLSearchParams(location.search);
  const transactionIdParam = searchParams.get("id");
  const businessIdParam = searchParams.get("business");
  const isFormSubmit = useRef(false);
  const isTypeSet = useRef(false);
  const selectTransactionTypeRef = useRef(false);

  const [aiEnabled, setaiEnabled] = useState(false);
  const [
    importDetectionMaintenanceVisible,
    setimportDetectionMaintenanceVisible,
  ] = useState(false);
  const [importDetectionEnabled, setimportDetectionEnabled] = useState(true);
  const [importDetectionStatus, setimportDetectionStatus] = useState("");
  const [showTermsModal, setshowTermsModal] = useState(false);

  const [premiumModalOpen, setpremiumModalOpen] = useState(false);
  const [premiumModalTitle, setpremiumModalTitle] = useState("");
  const [premiumModalDescription, setpremiumModalDescription] = useState("");
  const [premiumModalType, setpremiumModalType] = useState("");

  const dispatch = useBusinessTransactionDispatch();
  const accountingDispatch = useAccountingDispatch();
  const termsDispatch = useTermsDispatch();
  const userDispatch = useAuthDispatch();
  const { user } = useAuthState();

  const {
    minDate: periodMinDate,
    isDateClosed,
    isClosed: periodClosed,
    closedThroughLabel,
    refetch: refetchPeriod,
  } = usePeriodLock(selectedBusiness?.id, { locale: i18n.language });

  const {
    request: businessPartnerRequest,
    loading: businessLoading,
    businesses,
    businessPartners,
    businessPartnerLoading,
    businessPartnerError,
    newPartner,
    newPartnerLoading,
    newPartnerError,
    newTransaction,
    newTransactionLoading,
    newTransactionError,
    updateBusiness,
    error: updateBusinessError,
  } = useBusinessTransactionState();
  const {
    creditAccountRequest,
    debitAccountRequest,
    accounts,
    accountError,
    error,
    transactionID,
    transaction,
    submitLoading,
    submitError,
    accountLoading,
    allAccountLoading,
    initAccountLoading,
    initAccountStatus,
    debitLoading,
    debits,
    debitError,
    credits,
    creditLoading,
    creditError,
    deletedID,
    parentTransaction,
    uploadError,
    progressUpload,
    storageRequest,
    uploadLoading,
    excelUpload,
    uploadSuccess,
    uploadStatusError,
  } = useAccountingState();
  const {
    request: termsRequest,
    terms,
    termsLoading,
    termsError,
    termsAcceptances,
    acceptTermsLoading,
    acceptTermsError,
    removeAcceptanceLoading,
    removeAcceptanceError,
    statusAccept,
  } = useTermsState();

  const termsContent = terms?.contents?.items
    ?.find((item) => item.language === i18n.language)
    ?.content?.replace(/# (.*?)(?=\\n|$)/g, "<h1>$1</h1>");

  // Which profile fields are still missing on the selected business — drives
  // the optional selects shown before initializing the default chart.
  const effectiveType = typeSel?.value || selectedBusiness?.type || "";
  const missingType = Boolean(selectedBusiness) && !selectedBusiness.type;
  // Structure only applies to incorporated (BUSINESS) entities.
  const missingStructure =
    Boolean(selectedBusiness) &&
    !selectedBusiness.structure &&
    effectiveType === "BUSINESS";
  const missingCategory = Boolean(selectedBusiness) && !selectedBusiness.category;
  const needsProfile = missingType || missingStructure || missingCategory;

  const businessTypes = useMemo(() => {
    return [
      { label: "Personal", value: "PERSONAL" },
      { label: "Incorporated", value: "BUSINESS" },
    ].map((item) => ({
      ...item,
      label: t(item.label),
    }));
  }, [t]);

  const transactionTypes = useMemo(() => {
    // System-generated journals are posted by the backend, not entered by hand.
    const selectableTransactionTypes = TRANSACTION_TYPES.filter(
      (item) => !item.systemGenerated,
    );

    return selectableTransactionTypes.map((item) => ({
      ...item,
      label: t(item.label),
    }));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [TRANSACTION_TYPES, t]);

  const { isAccepted, termAcceptance } = useMemo(() => {
    const currentAcceptance = termsAcceptances?.find(
      (acceptance) => acceptance.termsAndConditions?.id === TERMS_ID
    );
    return {
      termAcceptance: currentAcceptance,
      isAccepted: Boolean(currentAcceptance?.id),
    };
  }, [termsAcceptances]);

  useEffect(() => {
    if (isAccepted && statusAccept && showTermsModal) {
      setshowTermsModal(false);
      clearTermsStatus(termsDispatch);
    }
  }, [isAccepted, showTermsModal, statusAccept, termsDispatch]);

  useEffect(() => {
    if (user?.username) {
      requestGetUser(userDispatch, { sub: user.username });
      requestListTermsAcceptance(termsDispatch, {
        termsID: TERMS_ID,
        userID: user.id,
      });
    }
  }, [user?.username, termsDispatch, userDispatch, user?.id]);

  useEffect(() => {
    onLoadTerms();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [importDetectionStatus, termsDispatch]);

  useEffect(() => {
    if (transaction?.invoiceNumber) {
      navigate(`/invoice/${transactionIdParam}`);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [transaction?.invoiceNumber]);

  useEffect(() => {
    if (transactionID) {
      clearAccountingTransaction(accountingDispatch);
      clearAcctTransactionError(accountingDispatch);
      resetNewBusinessTransaction(dispatch);
    }
    if (termsRequest) {
      cancelAPIRequest(termsRequest);
    }
    return () => {
      clearTermsStatus(termsDispatch);
      clearTermsError(termsDispatch);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Clear on unmount
  useEffect(() => {
    return () => {
      clearAccountingTransaction(accountingDispatch);
      clearAcctTransactionError(accountingDispatch);
      resetNewBusinessTransaction(dispatch);
    };
  }, [dispatch, accountingDispatch]);

  // Get transaction detail for edit
  useEffect(() => {
    if (transactionIdParam) {
      requestGetAccountingTransaction(accountingDispatch, {
        id: transactionIdParam,
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [transactionIdParam]);

  // Get parent transaction detail
  useEffect(() => {
    if (transaction?.parentTransactionID) {
      requestGetParentAccountingTransaction(accountingDispatch, {
        id: transaction.parentTransactionID,
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [transaction?.parentTransactionID]);

  // Set selected business from params
  useEffect(() => {
    if (businesses.length > 0) {
      if (businessIdParam || transaction?.businessID) {
        let business = {};
        if (businessIdParam) {
          business = businesses.find((item) => item.value === businessIdParam);
        }

        if (transaction?.businessID) {
          business = businesses.find(
            (item) => item.value === transaction.businessID
          );
        }

        if (business) {
          setSelectedBusiness({
            ...business,
            label: business.name,
            value: business.id,
          });
        }
      }
    }
  }, [
    businessIdParam,
    businesses,
    transaction?.businessID,
    transactionIdParam,
  ]);

  // Preload form for edit
  useEffect(() => {
    if (transaction?.id) {
      const { createdAt, total, description, type, partner, paymentDueAt } =
        transaction;

      setdate(new Date(createdAt));
      settotal({ floatValue: total, value: total });
      setdescription(description);

      if (partner) {
        setselectedPartner({
          ...partner,
          label: partner.name,
          value: partner.id,
        });
      }

      if (paymentDueAt) {
        setdueDate(new Date(paymentDueAt));
      }

      if (type) {
        const selectedType = transactionTypes.find(
          (item) => item.value === type
        );
        settransactionType(selectedType);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [transaction?.id]);

  // Load debit and credit accounts
  useEffect(() => {
    if (transaction?.id) {
      const { items } = transaction.accounts || {};
      if (transaction.type === "OTHER") {
        if (items) {
          const mappedItems = items.map((item) => {
            let accountLabel = item.account?.name;
            const selectedAccount = accounts.find(
              (account) => account.id === item.accountID
            );

            if (selectedAccount) {
              accountLabel = `${selectedAccount?.code} - ${selectedAccount?.name}`;
            }
            return {
              account: {
                label: accountLabel,
                value: item.account?.id,
              },
              debit: { value: `${item.debit}`, floatValue: item.debit },
              credit: { value: `${item.credit}`, floatValue: item.credit },
            };
          });
          setaccountItems(mappedItems);
        }
      } else {
        if (items) {
          items.forEach((account) => {
            if (account.debit > 0) {
              const { account: debitAccount } = account;
              setDebitAccount({
                ...debitAccount,
                label: debitAccount.name,
                value: debitAccount.id,
              });
            }
            if (account.credit > 0) {
              const { account: creditAccount } = account;
              setCreditAccount({
                ...creditAccount,
                label: creditAccount.name,
                value: creditAccount.id,
              });
            }
          });
        }
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [transaction?.id, accounts]);

  // List all business
  useEffect(() => {
    if (user.id) {
      requestListBusiness(dispatch, {
        owner: user.id,
        page: 1,
        limit: 10,
      });
    }
  }, [dispatch, user.id]);

  // List all accounts for selected business
  useEffect(() => {
    if (selectedBusiness?.id) {
      requestListAccount(accountingDispatch, {
        businessID: selectedBusiness.id,
      });
    } else {
      if (user.id) {
        requestListBusiness(dispatch, {
          owner: user.id,
          page: 1,
          limit: 10,
        });
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedBusiness?.id, user.id]);

  useEffect(() => {
    if (transactionType?.value === "OTHER" && selectedBusiness?.id) {
      requestListAccount(accountingDispatch, {
        businessID: selectedBusiness.id,
        loadAll: true,
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedBusiness?.id, transactionType?.value]);

  // Reload accounts after init success
  useEffect(() => {
    if (initAccountStatus === "SUCCESS") {
      requestListAccount(accountingDispatch, {
        businessID: selectedBusiness.id,
      });
      clearInitAccountStatus(accountingDispatch);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [initAccountStatus]);

  // Profile update done → run the actual init.
  useEffect(() => {
    if (updatingProfile && updateBusiness?.id === selectedBusiness?.id) {
      clearUpdateBusiness(dispatch);
      setUpdatingProfile(false);
      requestInitAccount(accountingDispatch, { businessID: selectedBusiness.id });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [updateBusiness?.id, updatingProfile]);

  // Profile update failed → stop waiting, error surfaces in the error modal.
  useEffect(() => {
    if (updatingProfile && updateBusinessError) {
      setUpdatingProfile(false);
    }
  }, [updateBusinessError, updatingProfile]);

  // Reload debit accounts if paid status changed
  useEffect(() => {
    if (debitAccountRequest) {
      cancelAPIRequest(debitAccountRequest);
    }
    if (!paid) {
      if (transactionType?.debitUnpaidAccounts && selectedBusiness?.id) {
        requestListDebitAccount(accountingDispatch, {
          businessID: selectedBusiness.id,
          categories: transactionType.debitUnpaidAccounts,
        });
      }
    } else {
      if (transactionType?.debitAccounts && selectedBusiness?.id) {
        requestListDebitAccount(accountingDispatch, {
          businessID: selectedBusiness.id,
          categories: transactionType.debitAccounts,
        });
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    transactionType?.debitAccounts,
    transactionType?.debitUnpaidAccounts,
    paid,
    selectedBusiness?.id,
  ]);

  // Reload credit accounts if paid status changed
  useEffect(() => {
    if (creditAccountRequest) {
      cancelAPIRequest(creditAccountRequest);
    }
    if (!paid) {
      if (transactionType?.creditUnpaidAccounts && selectedBusiness?.id) {
        requestListCreditAccount(accountingDispatch, {
          businessID: selectedBusiness.id,
          categories: transactionType.creditUnpaidAccounts,
        });
      }
    } else {
      if (transactionType?.creditAccounts && selectedBusiness?.id) {
        requestListCreditAccount(accountingDispatch, {
          businessID: selectedBusiness.id,
          categories: transactionType.creditAccounts,
        });
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    transactionType?.creditAccounts,
    transactionType?.creditUnpaidAccounts,
    paid,
    selectedBusiness?.id,
  ]);

  // Create transaction success
  useEffect(() => {
    if (transactionID && !cashbookSync) {
      setshowSuccessModal(true);
    } else if (transactionID && cashbookSync) {
      onCashbookSync();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [transactionID]);

  useEffect(() => {
    if (transactionID && newTransactionError) {
      setshowSuccessModal(true);
    }
  }, [transactionID, newTransactionError]);

  useEffect(() => {
    if (newTransaction?.id) {
      setshowSyncSuccess(true);
    }
  }, [newTransaction?.id]);

  // Create partner success
  useEffect(() => {
    if (newPartner) {
      setshowSuccessModal(true);
      setshowPartnerModal(false);
      if (newPartner.id && newPartner.name) {
        setselectedPartner({
          label: newPartner.name,
          value: newPartner.id,
        });
      }
    }
  }, [newPartner]);

  // Error handling
  useEffect(() => {
    const hasError = [
      submitError,
      newPartnerError,
      acceptTermsError,
      removeAcceptanceError,
    ].some((error) => error);

    if (hasError && !showTermsModal) {
      setshowErrorModal(true);
    }
  }, [
    submitError,
    newPartnerError,
    acceptTermsError,
    removeAcceptanceError,
    showTermsModal,
  ]);

  // Delete success
  useEffect(() => {
    if (!deletedID) {
      return;
    }
    setshowConfirmModal(false);
    setshowSuccessModal(true);
  }, [deletedID]);

  // List business partner for certain transaction
  useEffect(() => {
    if (selectedBusiness?.value) {
      if (partnerTransactionTypes.includes(transactionType?.value)) {
        if (businessPartnerRequest) {
          cancelAPIRequest(businessPartnerRequest);
        }
        requestListBusinessPartner(dispatch, {
          page: 1,
          businessID: selectedBusiness.value,
        });
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedBusiness?.value, transactionType?.value]);

  // Reset selected account if transaction type changed
  useEffect(() => {
    if (transactionType?.value) {
      setcashbookSync(false);
      if (isTypeSet.current) {
        setpaid(true);
        if (selectTransactionTypeRef.current) {
          setCreditAccount(null);
          setDebitAccount(null);
          selectTransactionTypeRef.current = false;
        }
      }
      isTypeSet.current = true;
    }
  }, [transactionType?.value]);

  // Reset selected account if transaction type changed
  useEffect(() => {
    setCreditAccount(null);
    setDebitAccount(null);
    setcashbookSync(false);
  }, [paid]);

  // Validate form if changed
  useEffect(() => {
    if (isFormSubmit.current) {
      validateForm();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    selectedBusiness,
    transactionType,
    date,
    debitAccount,
    creditAccount,
    total,
    selectedPartner,
    totalPaid,
    selectedAccount,
    paymentDate,
    partnerName,
    businessPartners,
    dueDate,
  ]);

  // Validate create partner modal form
  useEffect(() => {
    if (partnerSubmitted) {
      validatePartnerForm();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [partnerName, businessPartners, partnerSubmitted]);

  // Calculate total payment left
  useEffect(() => {
    if (total && transaction.payments && transaction.payments.items) {
      const totalPayments = transaction.payments.items.reduce(
        (total, payment) => total + (payment.total || 0),
        0
      );

      const difference = total.floatValue - totalPayments;

      settotalPaid(
        difference !== 0 ? { floatValue: difference, value: difference } : total
      );
    }
  }, [total, transaction, showPaymentModal]);

  useEffect(() => {
    if (
      selectedBusiness?.alwaysSync &&
      ["INCOME", "EXPENSE"].includes(transactionType?.value)
    ) {
      setcashbookSync(true);
    }
  }, [selectedBusiness, transactionType]);

  useEffect(() => {
    if (
      selectedBusiness &&
      selectedBusiness?.alwaysSync &&
      cashbookSync &&
      transactionType?.value === "INCOME"
    ) {
      const { cashIncomeDebitAccount, cashIncomeCreditAccount } =
        selectedBusiness;
      setDebitAccount({
        ...cashIncomeDebitAccount,
        value: cashIncomeDebitAccount.id,
        label: cashIncomeDebitAccount.name,
      });
      setCreditAccount({
        ...cashIncomeCreditAccount,
        value: cashIncomeCreditAccount.id,
        label: cashIncomeCreditAccount.name,
      });
    }
  }, [selectedBusiness, cashbookSync, transactionType]);

  useEffect(() => {
    if (
      selectedBusiness &&
      selectedBusiness?.alwaysSync &&
      cashbookSync &&
      transactionType?.value === "EXPENSE"
    ) {
      const { cashExpenseDebitAccount, cashExpenseCreditAccount } =
        selectedBusiness;
      if (cashExpenseDebitAccount) {
        setDebitAccount({
          ...cashExpenseDebitAccount,
          value: cashExpenseDebitAccount?.id,
          label: cashExpenseDebitAccount?.name,
        });
      }
      if (cashExpenseCreditAccount) {
        setCreditAccount({
          ...cashExpenseCreditAccount,
          value: cashExpenseCreditAccount?.id,
          label: cashExpenseCreditAccount?.name,
        });
      }
    }
  }, [selectedBusiness, cashbookSync, transactionType]);

  useEffect(() => {
    if (uploadSuccess) {
      setShowProgressModal(false);
      setshowSuccessModal(true);
    } else if (uploadError) {
      setshowErrorModal(true);
      setShowProgressModal(false);
    }
  }, [uploadSuccess, uploadError]);

  useEffect(() => {
    if (selectedFile) {
      setfileError(null);
    }
  }, [selectedFile]);

  const onLoadTerms = () => {
    if (importDetectionStatus !== "DISABLED") {
      requestGetTerms(termsDispatch, { id: TERMS_ID });
    }
  };

  const onChangeAcceptance = () => {
    if (isAccepted) {
      requestRemoveTermsAcceptance(termsDispatch, {
        acceptanceID: termAcceptance.id,
      });
    } else {
      requestAcceptTerms(termsDispatch, {
        termsID: TERMS_ID,
        userID: user.id,
      });
    }
  };

  // Send api pay payable and receivable transaction
  const handlePayment = (update = false) => {
    isFormSubmit.current = true;

    if (!validateForm()) return;
    if (isDateClosed(paymentDate)) return;
    const isPayablePayment = paymentTransactionTypes.includes(transaction.type);
    const isReceivableType = receivableTransactionTypes.includes(
      transactionType?.value
    );

    const input = {
      created_at: paymentDate.toISOString(),
      total: isPayablePayment ? total.floatValue : totalPaid.floatValue,
      accounts: [],
      description: isPayablePayment ? description : paymentDescription,
      paid: true,
      business_id: selectedBusiness.id,
      partner_id: selectedPartner?.value,
      parent_transaction_id: update
        ? transaction.parentTransactionID
        : transactionIdParam,
    };

    const creditAccountValue = creditAccount?.value;
    const debitAccountValue = debitAccount?.value;
    const selectedAccountValue = selectedAccount?.value;

    if (
      isReceivableType ||
      receivableTransactionTypes.includes(parentTransaction.type)
    ) {
      input.accounts.push({
        id: update ? debitAccountValue : selectedAccountValue,
        debit: input.total,
        credit: 0,
      });

      input.accounts.push({
        id: update ? creditAccountValue : debitAccountValue,
        debit: 0,
        credit: input.total,
      });

      input.type = "RECEIVABLE_PAYMENT";
    } else {
      input.accounts.push({
        id: update ? debitAccountValue : creditAccountValue,
        debit: input.total,
        credit: 0,
      });

      input.accounts.push({
        id: update ? creditAccountValue : selectedAccountValue,
        debit: 0,
        credit: input.total,
      });

      input.type = "PAYABLE_PAYMENT";
    }

    if (update) {
      input.transaction_id = transaction.id;
      requestUpdateAcctTransaction(accountingDispatch, { input });
    } else {
      requestCreateAcctTransaction(accountingDispatch, { input });
    }
  };

  // Navigate to transaction list when done creating
  const navigateToAccounting = () => {
    setshowSuccessModal(false);
    clearAccountingTransaction(accountingDispatch);
    if (!submitError) {
      if (transactionID || deletedID || newTransaction?.id) {
        navigate(`/accounting?id=${selectedBusiness.value}`);
      } else {
        if (excelUpload?.importID && aiEnabled) {
          navigate(`/accounting-transaction/draft/${excelUpload.importID}`);
        } else {
          navigate(`/accounting-transaction/import?id=${selectedBusiness.id}`);
        }
      }
    }
  };

  // Change transaction type
  const handleTransactionTypeChange = (selectedOption) => {
    settransactionType(selectedOption);
    selectTransactionTypeRef.current = true;
  };

  // Initialize accounts. Persist any profile answers first — the backend reads
  // structure/type/category off the Business record when it builds the chart.
  const handleInitAccount = () => {
    const updates = {};
    if (missingType && typeSel?.value) updates.type = typeSel.value;
    if (missingStructure && structureSel?.value)
      updates.structure = structureSel.value;
    if (missingCategory && categorySel?.value)
      updates.category = categorySel.value;

    if (Object.keys(updates).length > 0) {
      setUpdatingProfile(true);
      requestUpdateBusiness(dispatch, {
        input: { id: selectedBusiness.id, ...updates },
      });
    } else {
      requestInitAccount(accountingDispatch, {
        businessID: selectedBusiness?.id,
      });
    }
  };

  // Send api create partner
  const handlePartnerSave = () => {
    setpartnerSubmitted(true);
    if (validatePartnerForm()) {
      const input = {
        businessID: selectedBusiness.value,
        name: partnerName,
        type: businessType.value,
      };
      requestCreateBusinessPartner(dispatch, { input });
    }
  };

  // Send api create transaction
  const onSave = (update = false) => {
    isFormSubmit.current = true;
    setaccountItemsError("");
    if (isDateClosed(date)) return;

    const formValid = validateForm();

    if (formValid) {
      let selectedtransactionType;

      if (transactionType.value === "INCOME" && !paid) {
        selectedtransactionType = "INCOME_RECEIVABLE";
      }

      if (transactionType.value === "EXPENSE" && !paid) {
        selectedtransactionType = "EXPENSE_PAYABLE";
      }

      const input = {
        type: selectedtransactionType || transactionType.value,
        created_at: date.toISOString(),
        total: total.floatValue,
        accounts: [],
        description: description || "",
        paid: paid,
        business_id: selectedBusiness.id,
        payment_due_at: dueDate ? dueDate?.toISOString() : null,
      };

      if (selectedPartner?.value) {
        input.partner_id = selectedPartner.value;
      } else {
        input.partner_id = null;
      }

      if (creditAccount?.value) {
        input.accounts.push({
          id: creditAccount.value,
          debit: 0,
          credit: input.total,
        });
      }

      if (debitAccount?.value) {
        input.accounts.push({
          id: debitAccount.value,
          debit: input.total,
          credit: 0,
        });
      }

      if (["OTHER"].includes(transactionType?.value)) {
        if (accountItems.length < 2) {
          return;
        }

        input.accounts = accountItems.map(({ account, debit, credit }) => ({
          id: account.value,
          debit: debit.floatValue,
          credit: credit.floatValue,
        }));

        const encounteredIds = new Set();
        let duplicateFound = false;
        input.accounts.forEach(({ id }) => {
          if (encounteredIds.has(id)) {
            setaccountItemsError("Account cannot be the same.");
            duplicateFound = true;
            return;
          }
          encounteredIds.add(id);
        });

        if (duplicateFound) return;

        const totalDebit = input.accounts.reduce(
          (acc, { debit }) => acc + debit,
          0
        );
        const totalCredit = input.accounts.reduce(
          (acc, { credit }) => acc + credit,
          0
        );

        if (totalDebit !== totalCredit) {
          setaccountItemsError("Total debit and credit must be the same.");
          return;
        } else {
          setaccountItemsError("");
        }
        input.total = totalDebit || totalCredit;
      }

      if (update) {
        input.transaction_id = transaction.id;
        requestUpdateAcctTransaction(accountingDispatch, { input });
      } else {
        requestCreateAcctTransaction(accountingDispatch, { input });
      }
    }
  };

  const onCashbookSync = () => {
    if (cashbookSync && !submitError) {
      let income = 0;
      let expense = 0;

      if (transactionType.value === "INCOME") {
        income = total.floatValue;
      } else if (transactionType.value === "EXPENSE") {
        expense = total.floatValue;
      }

      const cashbookTransactionType = "SALE";

      const transactionData = {
        businessID: selectedBusiness.id,
        income,
        expense,
        type: cashbookTransactionType,
        createdAt: date.toISOString(),
        note: description,
      };

      if (selectedPartner?.value) {
        transactionData.partnerID = selectedPartner.value;
      }

      requestCreateBusinessTransaction(dispatch, { input: transactionData });
    }
  };

  // Validate create transaction form
  const validateForm = () => {
    let hasErrors = false;
    const validationErrors = {};

    setfieldError(false);
    setfieldErrorAccount(false);

    const validateRequiredField = (fieldName, fieldValue, displayFieldName) => {
      if (!fieldValue) {
        validationErrors[fieldName] = `${displayFieldName} is required.`;
        hasErrors = true;
        if (showPaymentModal === false) {
          setfieldError(true);
        }
      }
    };

    const validateDuplicateAccounts = () => {
      if (debitAccount?.value && creditAccount?.value) {
        if (debitAccount?.value === creditAccount?.value) {
          validationErrors.duplicateAccounts =
            "Debit and credit accounts cannot be the same";
          setfieldError(false);
          setfieldErrorAccount(true);
          hasErrors = true;
        }
      }
    };

    const validateDueDate = () => {
      if (dueDate) {
        const formattedDueDate = dayjs(dueDate).format("YYYY-MM-DD");
        const formattedDate = dayjs(date).format("YYYY-MM-DD");

        if (formattedDueDate < formattedDate) {
          validationErrors.dueDate =
            "Due date cannot be less than the transaction date.";
          setfieldError(false);
          hasErrors = true;
        }
      }
    };

    validateRequiredField("selectedBusiness", selectedBusiness, "Business");
    validateRequiredField("date", date, "Date");

    if (!["OTHER"].includes(transactionType?.value)) {
      validateRequiredField("debitAccount", debitAccount, "Debit account");
      validateRequiredField("creditAccount", creditAccount, "Credit account");
      validateRequiredField("total", total?.floatValue, "Total");
    }

    if (["OTHER"].includes(transactionType?.value)) {
      const validateAccount = accountItems.every((entry) => {
        return entry.account.value;
      });
      const validateDebitAmount = accountItems.every((entry) => {
        return entry.debit.floatValue !== undefined;
      });
      const validateCreditAmount = accountItems.every((entry) => {
        return entry.credit.floatValue !== undefined;
      });

      validateRequiredField("accountItems", validateAccount, "Account");
      validateRequiredField("debitAmount", validateDebitAmount, "Debit amount");
      validateRequiredField(
        "creditAmount",
        validateCreditAmount,
        "Credit amount"
      );

      for (const entry of accountItems) {
        const debit = entry.debit.floatValue;
        const credit = entry.credit.floatValue;

        if (!((debit !== 0 && credit === 0) || (debit === 0 && credit !== 0))) {
          validationErrors["debitCredit"] =
            "Debit and Credit amounts are invalid.";
          setinputErrors(validationErrors);
          return;
        }
      }
    }

    if (!paymentTransactionTypes.includes(transaction.type)) {
      validateRequiredField(
        "transactionType",
        transactionType,
        "Transaction type"
      );
    }

    if (
      (["INCOME", "EXPENSE"].includes(transactionType?.value) && !paid) ||
      [
        "INCOME_RECEIVABLE",
        "EXPENSE_PAYABLE",
        "PAYABLE",
        "RECEIVABLE",
      ].includes(transactionType?.value)
    ) {
      validateRequiredField(
        "selectedPartner",
        selectedPartner,
        "Partner or Customer"
      );
    }

    if (showPaymentModal) {
      validateRequiredField("selectedAccount", selectedAccount, "Account");
      validateRequiredField("paymentDate", paymentDate, "Date");
      validateRequiredField("totalPaid", totalPaid?.floatValue, "Total Paid");
    }

    if (showPartnerModal) {
      validateRequiredField("partnerName", partnerName, "Partner");
      validateRequiredField(
        "businessType",
        businessType.value,
        "Business Type"
      );
    }

    validateDuplicateAccounts();
    if (!paid) {
      validateDueDate();
    }

    setinputErrors(validationErrors);
    return !hasErrors;
  };

  // Validate create partner form
  const validatePartnerForm = () => {
    let hasErrors = false;
    const validationErrors = {};

    const validateRequiredField = (fieldName, fieldValue, displayFieldName) => {
      if (!fieldValue) {
        validationErrors[fieldName] = `${displayFieldName} is required`;
        hasErrors = true;
      }
    };

    validateRequiredField("partnerName", partnerName, "Partner");

    setinputErrors(validationErrors);
    return !hasErrors;
  };

  const resetPartnerModal = () => {
    setpartnerName("");
    setbusinessType("");
    setinputErrors("");
  };

  const handleRemoveRow = (index) => {
    const newAccountItems = [...accountItems];
    newAccountItems.splice(index, 1);
    setaccountItems(newAccountItems);
  };

  const updateAccountItem = (index, updatedProperties) => {
    return (prevState) => {
      const updatedItems = [...prevState];

      updatedItems[index] = {
        ...updatedItems[index],
        ...updatedProperties,
      };

      return updatedItems;
    };
  };

  const handleAddRow = () => {
    if (accountItems.length < 100) {
      setaccountItems([
        ...accountItems,
        {
          account: "",
          debit: { value: "0", floatValue: 0 },
          credit: { value: "0", floatValue: 0 },
        },
      ]);
    }
  };

  const renderPaymentModal = () => {
    return (
      <Modal
        title={
          receivableTransactionTypes.includes(transactionType?.value)
            ? t("Pay Receivable")
            : t("Pay Payable")
        }
        show={showPaymentModal}
        onClose={() => {
          setshowPaymentModal(false);
        }}
        footer={
          <div className="p-4 flex justify-end items-center bg-gray-50 rounded-b-lg">
            <Button
              disabled={submitLoading}
              loading={submitLoading}
              onClick={(e) => {
                e.preventDefault();
                handlePayment();
              }}
              className="w-24 shrink-0"
              title="Pay"
            />
          </div>
        }
      >
        <div className="flex flex-col gap-4 px-4 py-5">
          {selectedBusiness?.id && (
            <BusinessStatusBanner business={selectedBusiness} />
          )}
          {/* Inline and amber rather than the red modal below: a closed period
              is a status, and an alert dialog would also navigate the user away
              from the payment they were recording. */}
          <PeriodClosedNotice error={submitError} onRefresh={refetchPeriod} />
          {submitError && !getPeriodClosedError(submitError) && (
            <ModalConfirm
              open={showErrorModal}
              setOpen={(open) => {
                setshowErrorModal(open);
              }}
              title="Error"
              description={
                (submitError?.response?.body &&
                  JSON.parse(submitError.response.body)?.message) ||
                getErrorMessages(submitError)
              }
              type="ALERT"
              onConfirm={() => {
                navigateToAccounting();
                clearAcctTransactionError(accountingDispatch);
              }}
            />
          )}
          {transactionID && (
            <ModalConfirm
              open={showSuccessModal}
              setOpen={(open) => {
                setshowSuccessModal(open);
              }}
              title="Success"
              description={"Your payment transaction was successful."}
              type="SUCCESS"
              onConfirm={navigateToAccounting}
            />
          )}
          <div>
            <label
              htmlFor="paymentDate"
              className="block text-sm font-medium text-gray-700"
            >
              {t("Date")}
            </label>
            {/* A payment creates its own journal, so it is constrained too —
                unlike the due date, which may legitimately fall inside a
                closed period because it records no entry. */}
            <ReactDatePicker
              name="paymentDate"
              className="mt-1 block w-full text-sm rounded-md shadow-sm border-gray-300 focus:border-blue-500 focus:ring-blue-500"
              selected={paymentDate}
              onChange={setpaymentDate}
              placeholderText={t("Select Date")}
              dateFormat="dd/MM/yyyy"
              minDate={periodMinDate}
            />
            {inputErrors.paymentDate && (
              <div className="mt-1 text-red-600 text-sm">
                {t(inputErrors.paymentDate)}
              </div>
            )}
          </div>
          <div>
            <label
              htmlFor="totalPaid"
              className="block text-sm font-medium text-gray-700"
            >
              {t("Total Paid")}
            </label>
            <NumericFormat
              type="text"
              name="totalPaid"
              id="totalPaid"
              value={totalPaid.value || ""}
              placeholder={t("Enter Total Transaction")}
              thousandSeparator="."
              decimalSeparator=","
              displayType="input"
              prefix={"Rp"}
              onValueChange={(value) => settotalPaid(value)}
              className="mt-1 block w-full text-sm rounded-md shadow-sm border-gray-300 focus:border-blue-500 focus:ring-blue-500"
            />
            {inputErrors.totalPaid && (
              <div className="mt-1 text-red-600 text-sm">
                {t(inputErrors.totalPaid)}
              </div>
            )}
          </div>
          <div>
            <label
              htmlFor="selectedAccount"
              className="block text-sm font-medium text-gray-700"
            >
              {t("Payment Account")}
            </label>
            <Select
              name="selectedAccount"
              className="mt-1 text-sm"
              classNamePrefix="select2-selection"
              options={accounts
                .filter((account) => account.category === "CASH_AND_BANK")
                .map((account) => ({
                  value: account.id,
                  label: account.name,
                }))}
              value={selectedAccount}
              onChange={setselectedAccount}
              placeholder={t("Choose Account")}
              isDisabled={!transactionType || creditLoading}
              isLoading={creditLoading}
              maxMenuHeight={100}
            />
            {inputErrors.selectedAccount && (
              <div className="mt-1 text-red-600 text-sm">
                {t(inputErrors.selectedAccount)}
              </div>
            )}
          </div>
          <div>
            <label
              htmlFor="paymentDescription"
              className="block text-sm font-medium text-gray-700"
            >
              {t("Note")}
            </label>
            <input
              type="text"
              name="paymentDescription"
              value={paymentDescription || ""}
              placeholder={t("Enter Transaction Note")}
              onChange={(e) => setpaymentDescription(e.target.value)}
              className="mt-1 block w-full text-sm rounded-md shadow-sm border-gray-300 focus:border-blue-500 focus:ring-blue-500"
            />
          </div>
        </div>
      </Modal>
    );
  };

  const renderPartnerModal = () => {
    return (
      <Modal
        title={t("Add Partner")}
        show={showPartnerModal}
        onClose={() => {
          setshowPartnerModal(false);
          setpartnerSubmitted(false);
          resetPartnerModal();
          clearBusinessPartnerError(dispatch);
        }}
        footer={
          <div className="p-4 flex justify-end items-center bg-gray-50 rounded-b-lg">
            <Button
              disabled={newPartnerLoading}
              loading={newPartnerLoading}
              onClick={(e) => {
                e.preventDefault();
                handlePartnerSave();
              }}
              className="w-24 shrink-0"
              title="Save"
            />
          </div>
        }
      >
        <div className="flex flex-col gap-4 px-4 py-5">
          {newPartnerError && (
            <Alert
              title="Error"
              type="error"
              message={
                newPartnerError?.message ||
                "newPartnerError delete Transaction."
              }
              errors={newPartnerError?.errors}
            />
          )}
          <div>
            <FormLabel htmlFor="name" label={t("Name")} required />
            <input
              type="text"
              name="name"
              value={partnerName}
              placeholder={t("Enter Partner Name")}
              onChange={(e) => setpartnerName(e.target.value)}
              className={classNames(
                inputErrors.partnerName
                  ? "border-red-500 focus:border-red-500 focus:ring-red-500"
                  : "border-gray-300 focus:border-blue-500 focus:ring-blue-500",
                "mt-1 block w-full text-sm rounded-md shadow-sm"
              )}
            />
            {inputErrors.partnerName && (
              <div className="mt-1 text-red-600 text-sm">
                {t(inputErrors.partnerName)}
              </div>
            )}
          </div>
          <div>
            <FormLabel htmlFor="type" label={t("Business Type")} />
            <Select
              id="type"
              name="type"
              className={classNames(
                inputErrors.businessType
                  ? "border-red-500 focus:border-red-500 focus:ring-red-500"
                  : "border-gray-300 focus:border-blue-500 focus:ring-blue-500",
                "mt-1 text-sm"
              )}
              classNamePrefix="select2-selection"
              options={businessTypes}
              value={businessType}
              onChange={setbusinessType}
              placeholder={t("Select Business Type")}
              isLoading={creditLoading}
            />
            {inputErrors.businessType && (
              <div className="mt-1 text-red-600 text-sm">
                {t(inputErrors.businessType)}
              </div>
            )}
          </div>
        </div>
      </Modal>
    );
  };

  const onDelete = () => {
    requestDeleteAcctTransaction(accountingDispatch, {
      id: paidTransactionID,
    });
  };

  const renderPartnerError = (error) => {
    const messages = getErrorMessages(error);
    return (
      <div>
        <div className="flex justify-between">
          <FormLabel htmlFor="partner" label={t("Partner or Customer")} />
          {businessIdParam && (
            <button
              type="button"
              onClick={() => {
                setshowPartnerModal(true);
              }}
              className="text-blue-600 text-sm font-medium"
            >
              {t("Add Partner")}
            </button>
          )}
        </div>
        <div className="relative">
          <input
            type="text"
            name="partner"
            value={messages}
            className="mt-1 pr-3 py-2 w-full text-sm rounded-md shadow-sm border-red-500 text-red-500"
            disabled={businessPartnerError}
          />
          <button
            type="button"
            onClick={() => {
              if (businessIdParam) {
                requestListBusinessPartner(dispatch, {
                  page: 1,
                  businessID: businessIdParam,
                });
              }
            }}
            className="absolute inset-y-0 right-0 px-2 py-1 flex items-center"
          >
            <RefreshIcon className="w-6 h-6 text-blue-500" />
          </button>
        </div>
      </div>
    );
  };

  const EmptyAccount = () => {
    return initAccountLoading || updatingProfile ? (
      <EmptyBusinessSkeleton />
    ) : accountError ? (
      <div className="bg-white shadow-sm max-w-7xl mx-auto overflow-hidden px-4 py-6 sm:px-6 rounded-t-lg">
        <Alert
          title="Error"
          type="error"
          message={accountError?.message || "Error fetch accounting account."}
          errors={accountError?.errors}
        />
      </div>
    ) : (
      <div className="max-w-lg mx-auto w-full">
        <div className="bg-white shadow rounded-lg overflow-hidden">
          <div className="flex flex-col items-center px-6 py-8 sm:px-8">
            {/* Header */}
            <div className="flex h-12 w-12 items-center justify-center rounded-full bg-blue-50">
              <ClipboardListIcon className="h-6 w-6 text-blue-600" />
            </div>
            <h3 className="mt-4 text-lg font-semibold text-gray-900 text-center">
              {t("No Accounts")}
            </h3>
            <p className="mt-1 text-sm text-gray-500 text-center">
              {t("Please create an account first")}
            </p>

            {updateBusinessError && (
              <div className="mt-4 w-full">
                <Alert
                  title="Error"
                  type="error"
                  message={getErrorMessages(updateBusinessError)}
                />
              </div>
            )}

            {/* Optional profile completion */}
            {needsProfile && (
              <div className="mt-6 w-full rounded-lg border border-gray-200 bg-gray-50 p-4">
                <p className="text-sm text-gray-600">
                  {t("initAccountPrompt.profileHint")}
                </p>
                <div className="mt-4 flex flex-col gap-4 text-left">
                  {missingType && (
                    <div>
                      <FormLabel
                        htmlFor="initType"
                        label={t("businessType", "Jenis Usaha")}
                      />
                      <Select
                        name="initType"
                        id="initType"
                        className="mt-1 text-sm"
                        classNamePrefix="select2-selection"
                        options={BUSINESS_TYPES_OPTIONS}
                        value={typeSel}
                        onChange={setTypeSel}
                        isClearable
                        menuPortalTarget={document.body}
                        menuPosition="fixed"
                        styles={{
                          menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                        }}
                      />
                    </div>
                  )}
                  {missingStructure && (
                    <div>
                      <FormLabel
                        htmlFor="initEntityType"
                        label={t("businessEntityType")}
                      />
                      <Select
                        name="initEntityType"
                        id="initEntityType"
                        className="mt-1 text-sm"
                        classNamePrefix="select2-selection"
                        options={BUSINESS_ENTITY_TYPES}
                        placeholder={t("businessEntityInputPlaceholder")}
                        value={structureSel}
                        onChange={setStructureSel}
                        isClearable
                        menuPortalTarget={document.body}
                        menuPosition="fixed"
                        styles={{
                          menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                        }}
                      />
                    </div>
                  )}
                  {missingCategory && (
                    <div>
                      <FormLabel
                        htmlFor="initCategory"
                        label={t("businessCategory", "Kategori Usaha")}
                      />
                      <Select
                        name="initCategory"
                        id="initCategory"
                        className="mt-1 text-sm"
                        classNamePrefix="select2-selection"
                        options={BUSINESS_CATEGORIES}
                        placeholder={t(
                          "businessCategoryPlaceholder",
                          "Pilih Kategori Usaha"
                        )}
                        value={categorySel}
                        onChange={setCategorySel}
                        isClearable
                        menuPortalTarget={document.body}
                        menuPosition="fixed"
                        styles={{
                          menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                        }}
                      />
                    </div>
                  )}
                </div>
              </div>
            )}

            {/* Actions */}
            <div className="mt-6 flex w-full flex-col sm:flex-row gap-3">
              <Button
                className="flex-1 justify-center"
                onClick={handleInitAccount}
                title="Create Automatically"
              />
              <Button
                outline
                className="flex-1 justify-center"
                onClick={() =>
                  navigate(`/account/import?id=${selectedBusiness.id}`)
                }
                title="Import Using XLSX File"
              />
            </div>
          </div>
        </div>
      </div>
    );
  };

  const onDownloadProgress = (progress) => {
    const { transferredBytes, totalBytes } = progress;
    if (!totalBytes) {
      setdownloadProgress(0);
    } else {
      setdownloadProgress(transferredBytes / totalBytes);
    }
  };

  const downloadBlob = (blob, filename) => {
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = filename || "download";
    const clickHandler = () => {
      setTimeout(() => {
        URL.revokeObjectURL(url);
        a.removeEventListener("click", clickHandler);
      }, 150);
    };
    a.addEventListener("click", clickHandler, false);
    a.click();
    return a;
  };

  const downloadFile = async (key) => {
    try {
      setdownloading(true);

      const request = downloadData({
        path: `public/${key}`,
        options: {
          onProgress: onDownloadProgress,
        },
      });

      downloadRef.current = request;
      const result = await request.result;
      const fileName = getAccountingFileName(key);

      downloadBlob(result.body, fileName);
    } catch (downloadError) {
      if (downloadError.message !== "canceled") {
        await handleDownloadError(key);
      }
    } finally {
      setdownloading(false);
      setdownloadProgress(0);
    }
  };

  const handleDownloadError = async (key) => {
    try {
      const urlResult = await getUrl({
        path: `public/${key}`,
        options: {
          useAccelerateEndpoint: true,
        },
      });
      const signedURL = urlResult.url.href;
      window.open(signedURL);
    } catch (signedURLError) {
      setdownloadDocError(signedURLError);
    }
  };

  const renderFileModal = () => (
    <Modal
      title="Download File"
      show={downloading}
      onClose={() => {
        if (downloadRef.current) {
          const downloadTask = downloadRef.current;
          downloadTask.cancel();
        }
        setdownloading(false);
      }}
      footer={
        <div className="p-4 flex flex-row-reverse gap-2 justify-between items-center border-t border-gray-300 bg-gray-50 rounded-b-lg">
          <div className="flex-1 overflow-hidden">
            <div className="w-full">
              <p className="text-xs text-slate-500">{t("Downloading")}</p>
              <div className="w-full mt-1 bg-gray-200 rounded-md sm:rounded-lg dark:bg-gray-700">
                <div
                  className="bg-blue-600 text-xs font-medium text-blue-100 text-center p-0.5 leading-none rounded-full"
                  style={{
                    width: `${Math.round(downloadProgress * 100)}%`,
                  }}
                >
                  {Math.round(downloadProgress * 100)}%
                </div>
              </div>
            </div>
          </div>
        </div>
      }
    >
      <div className="bg-white p-4">
        <div className="flex justify-center">
          <DocumentIcon className="h-24 w-24 text-slate-500" />
        </div>
      </div>
    </Modal>
  );

  const renderDownloadError = () => {
    if (downloadDocError) {
      return (
        <ModalConfirm
          open={showDownloadErrorModal}
          type="ALERT"
          setOpen={(open) => {
            setshowDownloadErrorModal(open);
          }}
          title="Error"
          description={getErrorMessages(downloadDocError)}
          onConfirm={() => {
            setdownloadDocError(null);
          }}
        />
      );
    }
    return null;
  };

  const handleImportClick = (selectedFile) => {
    if (!selectedFile) {
      setfileError("Select a file before clicking Upload.");
      return;
    }

    if (!selectedBusiness?.id) {
      setinputErrors({ selectedBusiness: "Business is required." });
      return;
    }

    setfileError(null);
    setfieldError(false);
    setShowProgressModal(true);
    setinputErrors({});

    requestDocumentExcelAccTransactionUpload(accountingDispatch, {
      useDetection: aiEnabled,
      businessID: selectedBusiness.id,
      file: selectedFile,
    });
  };

  const handleFileUpload = (event) => {
    event.preventDefault();
    const file = event.dataTransfer
      ? event.dataTransfer.files[0]
      : event.target.files[0];
    const maxSize = 100 * 1024; // 100 KB

    if (
      file &&
      file.type ===
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" &&
      file.size <= maxSize &&
      file.name.length < 120
    ) {
      setfieldErrorFile({ status: false, message: "" });
      setselectedFile(file);
    } else {
      if (!file) {
        setfieldErrorFile({ status: true, message: "Please select a file." });
      } else if (
        file.type !==
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
      ) {
        setfieldErrorFile({
          status: true,
          message: "The file format must be Excel.",
        });
        event.target.value = "";
      } else if (file.size >= maxSize) {
        setfieldErrorFile({
          status: true,
          message: "File size should not exceed 100 KB",
        });
        event.target.value = "";
      } else if (file.name.length >= 120) {
        setfieldErrorFile({
          status: true,
          message: "The file name is too long, maximum 120 characters.",
        });
        event.target.value = "";
      }
    }
  };

  const renderProgressBar = (label, percentage) => (
    <div className="flex-1 overflow-hidden">
      <div className="w-full">
        <p className="text-xs text-slate-500">{t(label)}</p>
        <div className="w-full mt-1 bg-gray-200 rounded-md sm:rounded-lg dark:bg-gray-700">
          <div
            className="bg-blue-600 text-xs font-medium text-blue-100 text-center p-0.5 leading-none rounded-full"
            style={{ width: `${percentage}%` }}
          >
            {percentage}%
          </div>
        </div>
      </div>
    </div>
  );

  const renderProgressModal = () => (
    <Modal
      title="Excel Document Upload Process"
      show={showProgressModal}
      onClose={() => {
        setShowProgressModal(false);
      }}
      footer={
        <div className="p-4 flex flex-row-reverse gap-2 justify-between items-center border-t border-gray-300 bg-gray-50 rounded-b-lg">
          {uploadLoading
            ? storageRequest !== null
              ? renderProgressBar(
                  "Processing",
                  Math.round(
                    (progressUpload?.transferredBytes /
                      progressUpload?.totalBytes) *
                      100
                  ),
                  100
                )
              : renderProgressBar("Uploading Excel Document File", 100)
            : null}
        </div>
      }
    >
      <div className="bg-white p-4">
        <div className="flex flex-col justify-center items-center">
          <DocumentIcon className="h-24 w-24 text-slate-500" />
          <div className="w-full text-center">
            <p className="text-xs text-slate-500 truncate">
              {selectedFile?.name}
            </p>
          </div>
        </div>
      </div>
    </Modal>
  );

  const handleNoPremium = () => {
    setpremiumModalType("WARNING");
    setpremiumModalTitle(t("Premium Feature"));
    setpremiumModalDescription(t("premiumAutomaticDetectionTitle"));
    setpremiumModalOpen(true);
  };

  const handleShowTerms = () => {
    if (Boolean(termsError)) {
      onLoadTerms();
    } else {
      setshowTermsModal(true);
    }
  };

  const renderTermsModal = () => (
    <Modal
      title="termsTitle"
      show={showTermsModal}
      onClose={() => {
        setshowTermsModal(false);
        clearTermsError(termsDispatch);
        if (termsRequest) {
          cancelAPIRequest(termsRequest);
        }
      }}
      footer={
        <div className="p-4 flex justify-end items-center bg-gray-50 rounded-b-lg gap-4">
          <Button
            onClick={() => {
              setshowTermsModal(false);
              clearTermsError(termsDispatch);
              if (termsRequest) {
                cancelAPIRequest(termsRequest);
              }
            }}
            title="Cancel"
            outline
          />
          <Button
            loading={acceptTermsLoading}
            disabled={acceptTermsLoading || isAccepted || !termsContent}
            onClick={() => {
              requestAcceptTerms(termsDispatch, {
                termsID: TERMS_ID,
                userID: user.id,
              });
            }}
            title={isAccepted ? "approvalConfirmed" : "Agree"}
          />
        </div>
      }
    >
      <div className="p-4">
        {acceptTermsError && (
          <Alert
            title="Error"
            type="error"
            className="mb-4"
            message={acceptTermsError?.message}
            errors={acceptTermsError?.errors}
          />
        )}
        <div className="text-sm text-gray-700">
          <Markdown
            rehypePlugins={rawMarkdownRehypePlugins}
            remarkPlugins={[remarkGfm]}
            components={{
              p({ children }) {
                return <p className="mb-2 last:mb-0">{children}</p>;
              },
              h1({ children }) {
                return <h1 className="text-bold text-2xl">{children}</h1>;
              },
              h2({ children }) {
                return <h2 className="text-bold text-xl">{children}</h2>;
              },
              h3({ children }) {
                return <h3 className="text-bold text-lg">{children}</h3>;
              },
              ol({ children }) {
                return <ol className="list-inside list-decimal">{children}</ol>;
              },
              ul({ children }) {
                return <ul className="list-inside list-disc">{children}</ul>;
              },
              li({ children }) {
                return (
                  <li className="mb-2 list-item list-inside">{children}</li>
                );
              },
              blockquote({ children }) {
                return (
                  <blockquote className="relative border-s-4 border-gray-800 bg-slate-200 pl-2 ps-4 sm:ps-6">
                    {children}
                  </blockquote>
                );
              },
            }}
          >
            {termsContent || t("termsNotAvailable")}
          </Markdown>
        </div>
      </div>
    </Modal>
  );

  const termsSwitchDisabled = termsError || !termsContent;

  const isButtonDisabled =
    importDetectionStatus !== "DISABLED" &&
    !isAccepted &&
    (aiEnabled || termsSwitchDisabled);

  const isUnavailable =
    importDetectionStatus === "OFFLINE" ||
    importDetectionStatus === "SCHEDULED_OFFLINE" ||
    importDetectionStatus === "SCHEDULED_ACTIVE";

  const renderMaintenanceBadge = () => {
    const badgeValue = isUnavailable ? "unavailable" : "maintenance";
    const badgeStyle = isUnavailable ? "secondary" : "alert";

    return (
      <div className="flex items-center">
        <Badge title={badgeValue} type={badgeStyle} />
      </div>
    );
  };

  if (accountLoading || configLoading) {
    return <EmptyBusinessSkeleton />;
  }

  if (
    accounts.length === 0 &&
    !allAccountLoading &&
    selectedBusiness?.id &&
    !transaction?.id
  ) {
    return <EmptyAccount />;
  }

  if (!transaction) {
    return (
      <div className="bg-white min-h-full rounded-lg p-4">
        <Alert
          type="error"
          title="Error"
          message={error?.message || "Accounting transaction not found."}
        />
      </div>
    );
  }

  const sortAccountCode = (a, b) => {
    const aCode = parseInt(a.code, 10);
    const bCode = parseInt(b.code, 10);
    return (aCode < 400000) - (bCode < 400000) || aCode - bCode;
  };

  function handleDragOver(event) {
    event.preventDefault();
  }

  function handleDragLeave(event) {
    event.preventDefault();
  }

  if (businesses.length > 0) {
    return (
      <div className="max-w-4xl grid grid-cols-1 gap-6 lg:max-w-7xl lg:grid-flow-col-dense lg:grid-cols-3">
        {uploadLoading && renderProgressModal()}
        {renderFileModal()}
        {renderDownloadError()}
        {renderTermsModal()}
        <MaintenanceModal
          isVisible={importDetectionMaintenanceVisible}
          onClose={() => setimportDetectionMaintenanceVisible(false)}
          onChangeAvailability={(available) =>
            setimportDetectionEnabled(available)
          }
          onChangeStatus={(status) => setimportDetectionStatus(status)}
          configValue={importDetectionConfig}
        />
        {uploadSuccess && (
          <ModalConfirm
            open={showSuccessModal}
            setOpen={(open) => {
              setshowSuccessModal(open);
            }}
            title="Success"
            description={"Successfully uploaded Excel document."}
            type="SUCCESS"
            onConfirm={navigateToAccounting}
          />
        )}
        {uploadStatusError && (
          <ModalConfirm
            open={showErrorModal}
            type="ALERT"
            setOpen={(open) => {
              setshowErrorModal(open);
            }}
            title="Error"
            description={getErrorMessages(uploadError)}
            onConfirm={() => {
              setshowErrorModal(false);
              if (aiEnabled) {
                clearDocumentExcelUploadStatus(accountingDispatch);
              } else {
                navigate(
                  `/accounting-transaction/import?id=${selectedBusiness.id}`
                );
              }
            }}
          />
        )}
        {(acceptTermsError || removeAcceptanceError) && (
          <ModalConfirm
            open={showErrorModal}
            type="ALERT"
            setOpen={(open) => {
              setshowErrorModal(open);
            }}
            title="Error"
            description={getErrorMessages(
              acceptTermsError || removeAcceptanceError
            )}
            onConfirm={() => {
              clearTermsError(termsDispatch);
            }}
          />
        )}

        <ModalConfirm
          open={
            premiumModalOpen &&
            premiumModalTitle !== "" &&
            premiumModalDescription !== ""
          }
          setOpen={(open) => {
            setpremiumModalOpen(open);
          }}
          title={premiumModalTitle}
          description={premiumModalDescription}
          type={premiumModalType}
          confirmTitle={t("Subscribe")}
          onConfirm={() => {
            navigate("/subscription");
          }}
        />

        {!transactionIdParam && (
          <div className="lg:col-start-3 lg:col-span-1">
            <div className="flex flex-col gap-4 p-4 rounded-lg bg-white">
              <div className="flex flex-col gap-4">
                <p className="font-medium text-gray-900">
                  {t("Import Transactions via Excel")}
                </p>
                <p className="text-sm text-gray-700">
                  {t("Download the")}{" "}
                  <button
                    onClick={() =>
                      downloadFile(
                        "template/accounting_transaction_template.xlsx"
                      )
                    }
                    className="text-blue-600"
                  >
                    {t("Excel format")}
                  </button>
                  {". "}
                  {t(
                    "Modify the Excel file according to your transaction data and upload it using the form below."
                  )}
                </p>
              </div>
              {importDetectionStatus !== "DISABLED" && (
                <div className="flex flex-col gap-2">
                  <div>
                    <p className="text-sm text-gray-700 mb-4">
                      {t("aiDetectionDescription")}
                    </p>
                    <div className="flex justify-between">
                      <label className="block text-sm font-medium text-gray-700">
                        {t("Settings")}
                      </label>
                      <button
                        type="button"
                        onClick={() =>
                          navigate(
                            `/accounting-transaction/draft?business=${selectedBusiness?.id}`
                          )
                        }
                        className="text-sm font-medium text-blue-600"
                      >
                        {t("history")}
                      </button>
                    </div>
                    <Field className="flex items-center py-2 px-3 mt-1 border border-gray-300 rounded-md">
                      <Switch
                        checked={aiEnabled}
                        disabled={!importDetectionEnabled && isUnavailable}
                        onChange={() => {
                          if (importDetectionEnabled) {
                            setaiEnabled(!aiEnabled);
                          } else {
                            setimportDetectionMaintenanceVisible(true);
                          }
                        }}
                        className={classNames(
                          aiEnabled ? "bg-blue-600" : "bg-gray-200",
                          "relative inline-flex flex-shrink-0 h-6 w-11 disabled:cursor-not-allowed border-2 border-transparent rounded-full cursor-pointer transition-colors ease-in-out duration-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
                        )}
                      >
                        <span
                          className={classNames(
                            aiEnabled ? "translate-x-5" : "translate-x-0",
                            !importDetectionEnabled && isUnavailable
                              ? "bg-gray-300"
                              : "bg-white",
                            "pointer-events-none relative inline-block h-5 w-5 rounded-full shadow transform ring-0 transition ease-in-out duration-200"
                          )}
                        >
                          <span
                            className={classNames(
                              aiEnabled
                                ? "opacity-0 ease-out duration-100"
                                : "opacity-100 ease-in duration-200",
                              "absolute inset-0 h-full w-full flex items-center justify-center transition-opacity"
                            )}
                            aria-hidden="true"
                          >
                            <svg
                              className="h-3 w-3 text-gray-400"
                              fill="none"
                              viewBox="0 0 12 12"
                            >
                              <path
                                d="M4 8l2-2m0 0l2-2M6 6L4 4m2 2l2 2"
                                stroke="currentColor"
                                strokeWidth={2}
                                strokeLinecap="round"
                                strokeLinejoin="round"
                              />
                            </svg>
                          </span>
                          <span
                            className={classNames(
                              aiEnabled
                                ? "opacity-100 ease-in duration-200"
                                : "opacity-0 ease-out duration-100",
                              "absolute inset-0 h-full w-full flex items-center justify-center transition-opacity"
                            )}
                            aria-hidden="true"
                          >
                            <svg
                              className="h-3 w-3 text-blue-600"
                              fill="currentColor"
                              viewBox="0 0 12 12"
                            >
                              <path d="M3.707 5.293a1 1 0 00-1.414 1.414l1.414-1.414zM5 8l-.707.707a1 1 0 001.414 0L5 8zm4.707-3.293a1 1 0 00-1.414-1.414l1.414 1.414zm-7.414 2l2 2 1.414-1.414-2-2-1.414 1.414zm3.414 2l4-4-1.414-1.414-4 4 1.414 1.414z" />
                            </svg>
                          </span>
                        </span>
                      </Switch>
                      <Label
                        as="span"
                        className="flex flex-1 justify-between ml-3"
                      >
                        <span className="text-sm text-gray-700">
                          {t("aiDetectionEnabledDescription")}
                        </span>
                        {importDetectionEnabled ? (
                          <div>
                            <SparklesIcon className="h-6 w-6 text-yellow-500" />
                          </div>
                        ) : (
                          renderMaintenanceBadge()
                        )}
                      </Label>
                    </Field>
                  </div>

                  <div>
                    <div className="flex justify-between">
                      <label className="block text-sm font-medium text-gray-700">
                        {t("approvalLabel")}
                      </label>
                    </div>
                    {termsLoading ||
                    acceptTermsLoading ||
                    removeAcceptanceLoading ? (
                      <div className="animate-pulse flex items-center justify-between py-2 px-3 mt-1 border border-gray-300 rounded-md gap-4">
                        <div className="flex flex-1 gap-2 items-center">
                          <div className="h-6 w-12 bg-gray-300 rounded-xl" />
                          <div className="h-4 w-1/2 bg-gray-300 rounded-md" />
                        </div>
                        <div className="h-6 w-6 bg-gray-300 rounded-md " />
                      </div>
                    ) : (
                      <Field className="flex items-center py-2 px-3 mt-1 border border-gray-300 rounded-md gap-2">
                        <Switch
                          checked={isAccepted}
                          disabled={termsSwitchDisabled}
                          onChange={onChangeAcceptance}
                          className={classNames(
                            isAccepted ? "bg-blue-600" : "bg-gray-200",
                            "relative inline-flex flex-shrink-0 h-6 w-11 disabled:cursor-not-allowed border-2 border-transparent rounded-full cursor-pointer transition-colors ease-in-out duration-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
                          )}
                        >
                          <span
                            className={classNames(
                              isAccepted ? "translate-x-5" : "translate-x-0",
                              termsSwitchDisabled ? "bg-gray-300" : "bg-white",
                              "pointer-events-none relative inline-block h-5 w-5 rounded-full shadow transform ring-0 transition ease-in-out duration-200"
                            )}
                          >
                            <span
                              className={classNames(
                                isAccepted
                                  ? "opacity-0 ease-out duration-100"
                                  : "opacity-100 ease-in duration-200",
                                "absolute inset-0 h-full w-full flex items-center justify-center transition-opacity"
                              )}
                              aria-hidden="true"
                            >
                              <svg
                                className="h-3 w-3 text-gray-400"
                                fill="none"
                                viewBox="0 0 12 12"
                              >
                                <path
                                  d="M4 8l2-2m0 0l2-2M6 6L4 4m2 2l2 2"
                                  stroke="currentColor"
                                  strokeWidth={2}
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                />
                              </svg>
                            </span>
                            <span
                              className={classNames(
                                isAccepted
                                  ? "opacity-100 ease-in duration-200"
                                  : "opacity-0 ease-out duration-100",
                                "absolute inset-0 h-full w-full flex items-center justify-center transition-opacity"
                              )}
                              aria-hidden="true"
                            >
                              <svg
                                className="h-3 w-3 text-blue-600"
                                fill="currentColor"
                                viewBox="0 0 12 12"
                              >
                                <path d="M3.707 5.293a1 1 0 00-1.414 1.414l1.414-1.414zM5 8l-.707.707a1 1 0 001.414 0L5 8zm4.707-3.293a1 1 0 00-1.414-1.414l1.414 1.414zm-7.414 2l2 2 1.414-1.414-2-2-1.414 1.414zm3.414 2l4-4-1.414-1.414-4 4 1.414 1.414z" />
                              </svg>
                            </span>
                          </span>
                        </Switch>
                        <div className="flex flex-1 justify-between">
                          <Label>
                            <span
                              className={`text-sm ${
                                termsError ? "text-red-600" : "text-gray-700"
                              }`}
                            >
                              {t(
                                termsError
                                  ? "failedToLoadTermsLabel"
                                  : "termsAgreeLabel"
                              )}
                            </span>
                          </Label>
                          <button onClick={handleShowTerms}>
                            {termsError ? (
                              <RefreshIcon className="h-6 w-6 text-gray-700" />
                            ) : (
                              <ClipboardListIcon className="h-6 w-6 text-blue-500" />
                            )}
                          </button>
                        </div>
                      </Field>
                    )}
                  </div>
                </div>
              )}
              <div className="flex gap-4">
                <div className="flex-1 overflow-hidden">
                  <div className="flex">
                    <label
                      htmlFor="upload-input"
                      className={classNames(
                        fileError
                          ? "border-red-500 focus:border-red-500 focus:ring-red-500"
                          : "focus:ring-blue-500 focus:border-blue-500 border-gray-300",
                        "items-center whitespace-nowrap px-4 py-2 bg-gray-100 border-y border-l border-gray-300 rounded-l-md cursor-pointer text-sm text-gray-600 hover:bg-gray-200 focus:bg-blue-50 focus:outline-none disabled:opacity-25 transition"
                      )}
                      onDragOver={handleDragOver}
                      onDrop={handleFileUpload}
                      onDragLeave={handleDragLeave}
                    >
                      {t("Choose File")}
                      <input
                        type="file"
                        id="upload-input"
                        className="sr-only"
                        onChange={handleFileUpload}
                        accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                      />
                    </label>
                    <div
                      className={classNames(
                        fileError
                          ? "border-red-500 focus:border-red-500 focus:ring-red-500"
                          : "focus:ring-blue-500 focus:border-blue-500 border-gray-300",
                        "flex w-full border rounded-r-md px-4 py-2 overflow-hidden"
                      )}
                      onDragOver={handleDragOver}
                      onDrop={handleFileUpload}
                      onDragLeave={handleDragLeave}
                    >
                      <span className="align-middle text-gray-400 text-sm truncate">
                        {selectedFile?.name || t("File not selected")}
                      </span>
                    </div>
                  </div>
                  {fileError && (
                    <div className="mt-1 text-red-600 text-sm">
                      {t(fileError)}
                    </div>
                  )}
                </div>
                <div>
                  <Button
                    disabled={isButtonDisabled}
                    onClick={() => {
                      if (user && user.membership !== "PREMIUM" && aiEnabled) {
                        handleNoPremium();
                      } else {
                        handleImportClick(selectedFile);
                      }
                    }}
                    title={t("Upload")}
                  />
                </div>
              </div>
            </div>
          </div>
        )}

        <div className="flex flex-col space-y-6 lg:col-start-1 lg:col-span-2">
          {paymentTransactionTypes.includes(transaction.type) && (
            <a
              href={
                parentTransaction.invoiceNumber
                  ? `/invoice/${parentTransaction.id}`
                  : `/accounting-transaction/create?id=${parentTransaction.id}`
              }
              className="bg-white border sm:w-1/2 w-full border-gray-200 divide-y divide-gray-200 shadow-sm sm:overflow-hidden rounded-md sm:rounded-lg"
            >
              <div className="px-4 py-6 sm:px-6">
                <div className="flex">
                  <div className="flex flex-1 gap-4">
                    <div className="flex items-center">
                      <div className="p-2 bg-amber-100 border border-amber-300 rounded-lg">
                        {["PAYABLE", "EXPENSE_PAYABLE"].includes(
                          parentTransaction.type
                        ) ? (
                          <ArrowSmRightIcon className="w-6 h-6 text-amber-600 rotate-45" />
                        ) : (
                          <ArrowSmUpIcon className="w-6 h-6 text-amber-600 rotate-45" />
                        )}
                      </div>
                    </div>
                    <div className="flex items-start flex-col">
                      <p className="font-medium">
                        {t(convertToTitleCase(parentTransaction?.type))}
                      </p>
                      <p className="text-sm">
                        {dayjs(parentTransaction.createdAt)
                          .locale(i18n.language)
                          .format("DD MMM YYYY")}
                      </p>
                    </div>
                  </div>
                  <div className="flex flex-col items-end">
                    <NumericFormat
                      className="text-sm"
                      displayType={"text"}
                      value={parentTransaction.total}
                      thousandSeparator={"."}
                      decimalSeparator={","}
                      prefix={"Rp"}
                    />
                    <p className="text-sm">
                      {t(parentTransaction.description)}
                    </p>
                  </div>
                </div>
              </div>
            </a>
          )}
          <div className="bg-white border border-gray-200 divide-y divide-gray-200 shadow-sm sm:overflow-hidden rounded-md sm:rounded-lg">
            {renderPaymentModal()}
            {renderPartnerModal()}
            {(transactionID || paidTransactionID) &&
              !cashbookSync &&
              !showPaymentModal && (
                <ModalConfirm
                  open={showSuccessModal}
                  setOpen={(open) => {
                    setshowSuccessModal(open);
                  }}
                  title="Success"
                  description={
                    transactionIdParam
                      ? deletedID
                        ? "Your payment transaction has been successfully deleted."
                        : "Your transaction has been saved."
                      : "Your transaction has been created."
                  }
                  type="SUCCESS"
                  onConfirm={navigateToAccounting}
                />
              )}
            {newPartner && (
              <ModalConfirm
                open={showSuccessModal}
                setOpen={(open) => {
                  setshowSuccessModal(open);
                }}
                title="Success"
                description={"Your new partner has been created."}
                type="SUCCESS"
                onConfirm={() => {
                  setshowPartnerModal(false);
                  setshowSuccessModal(false);
                  clearBusinessPartner(dispatch);
                  setpartnerSubmitted(false);
                  resetPartnerModal();
                }}
              />
            )}
            {((transactionID && newTransaction?.id) || newTransaction?.id) && (
              <ModalConfirm
                open={showSyncSuccess}
                setOpen={(open) => {
                  setshowSyncSuccess(open);
                }}
                title="Success"
                description="Your transaction has been created and successfully synchronized to cashbook."
                type="SUCCESS"
                onConfirm={navigateToAccounting}
              />
            )}
            {transactionID && newTransactionError && (
              <ModalConfirm
                open={showSuccessModal}
                setOpen={(open) => {
                  setshowSuccessModal(open);
                }}
                title="Warning"
                description="Your transaction has been created but failed to sync to cashbook."
                type="WARNING"
              />
            )}
            {fieldError && (
              <div className="px-4 py-6 sm:px-6">
                <Alert
                  title="Incomplete Form"
                  type="warning"
                  message="Please fill out all fields."
                />
              </div>
            )}
            {fieldErrorAccount && (
              <div className="px-4 py-6 sm:px-6">
                <Alert
                  title="Incomplete Form"
                  type="warning"
                  message={t("Debit and credit accounts cannot be the same")}
                />
              </div>
            )}

            {(newTransactionError ||
              (submitError && !getPeriodClosedError(submitError))) &&
              !showPaymentModal && (
              <div className="px-4 py-6 sm:px-6">
                <Alert
                  title={submitError ? "Error" : "Error Sync to Cashbook"}
                  type="error"
                  message={
                    submitError
                      ? (submitError?.response?.body &&
                          JSON.parse(submitError.response.body)?.message) ||
                        submitError?.message
                      : newTransactionError?.message ||
                        "Error create Transaction."
                  }
                  errors={submitError?.errors || newTransactionError?.errors}
                />
              </div>
            )}
            {
              <ModalAlert
                open={showConfirmModal}
                setOpen={(open) => {
                  setshowConfirmModal(open);
                }}
                title="Delete Transaction"
                description="Are you sure you want to delete this payment transaction?"
                confirmButtonText="Yes"
                cancelButtonText="Cancel"
                loadingButton={submitLoading}
                disabledButton={submitLoading}
                onConfirm={onDelete}
              />
            }
            <form>
              <div className="space-y-6 px-4 py-5 sm:p-6">
                {/* Explains why Save/Create below is disabled on a restricted or
                    pending-deletion business. No onRecord — the user is already
                    on the record page, so only the message + subscribe CTA show. */}
                {selectedBusiness?.id && (
                  <BusinessStatusBanner business={selectedBusiness} />
                )}
                <PeriodLockBanner businessID={selectedBusiness?.id} />
                <PeriodClosedNotice
                  error={submitError}
                  onRefresh={refetchPeriod}
                />
                {fieldErrorFile.status && (
                  <Alert
                    title="File Error"
                    type="warning"
                    message={fieldErrorFile.message}
                  />
                )}
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
                  {!paymentTransactionTypes.includes(transaction.type) && (
                    <>
                      <div>
                        <FormLabel
                          htmlFor="business"
                          label={t("Business Name")}
                          required
                        />
                        <Select
                          name="business"
                          className="mt-1 text-sm"
                          classNamePrefix="select2-selection"
                          options={businesses}
                          isLoading={businessLoading}
                          isDisabled={
                            businessLoading ||
                            paymentTransactionTypes.includes(
                              transaction.type
                            ) ||
                            businesses.length === 0
                          }
                          placeholder={
                            businesses.length === 0
                              ? t("No Business Profile Yet")
                              : t("Select Business Name")
                          }
                          value={selectedBusiness || ""}
                          onChange={setSelectedBusiness}
                        />
                        {inputErrors.selectedBusiness && (
                          <div className="mt-1 text-red-600 text-sm">
                            {t(inputErrors.selectedBusiness)}
                          </div>
                        )}
                      </div>

                      <div>
                        <FormLabel
                          htmlFor="transactionType"
                          label={t("Transaction Type")}
                          required
                        />
                        <Select
                          name="transactionType"
                          className="mt-1 text-sm"
                          classNamePrefix="select2-selection"
                          options={transactionTypes}
                          placeholder={t("Select Transaction Type")}
                          value={transactionType}
                          onChange={handleTransactionTypeChange}
                          isDisabled={
                            !selectedBusiness ||
                            paymentTransactionTypes.includes(
                              transaction.type
                            ) ||
                            transaction?.payments?.items?.length > 0
                          }
                        />
                        {inputErrors.transactionType && (
                          <div className="mt-1 text-red-600 text-sm">
                            {t(inputErrors.transactionType)}
                          </div>
                        )}
                      </div>
                    </>
                  )}
                  {["INCOME", "EXPENSE"].includes(transactionType?.value) && (
                    <div className="sm:col-span-2">
                      <FormLabel
                        htmlFor="payment-status"
                        label={t("Payment Status")}
                        required
                      />
                      <fieldset className="mt-4">
                        <div className="flex gap-4">
                          <div className="flex items-center">
                            <input
                              name="type"
                              type="radio"
                              value={paid}
                              onChange={() => setpaid(true)}
                              className="focus:text-blue-600 h-4 w-4 text-blue-600 border-gray-300"
                              checked={paid}
                            />
                            <label
                              htmlFor="type"
                              className="ml-3 block text-sm font-medium text-gray-700"
                            >
                              {t("Paid")}
                            </label>
                          </div>
                          <div className="flex items-center">
                            <input
                              name="type"
                              type="radio"
                              value={paid}
                              onChange={() => setpaid(false)}
                              className="focus:text-blue-600 h-4 w-4 text-blue-600 border-gray-300"
                              checked={!paid}
                            />
                            <label
                              htmlFor="type"
                              className="ml-3 block text-sm font-medium text-gray-700"
                            >
                              {t("Not Yet Paid")}
                            </label>
                          </div>
                        </div>
                      </fieldset>
                    </div>
                  )}
                  {!paymentTransactionTypes.includes(transaction.type) &&
                    !["OTHER"].includes(transactionType?.value) && (
                      <>
                        <div>
                          <FormLabel
                            htmlFor="debitAccount"
                            label={t(
                              transactionType?.debitLabel || "Debit Account"
                            )}
                            required
                          />
                          <Select
                            name="debitAccount"
                            className="mt-1 text-sm"
                            classNamePrefix="select2-selection"
                            value={debitAccount}
                            onChange={setDebitAccount}
                            options={debits
                              .slice()
                              .sort(sortAccountCode)
                              .map((obj) => ({
                                value: obj.id,
                                label: `${obj.code} - ${obj.name}`,
                              }))}
                            placeholder={t("Choose Debit Account")}
                            isDisabled={
                              !transactionType ||
                              debitLoading ||
                              transaction?.payments?.items?.length > 0
                            }
                            isLoading={debitLoading}
                            menuPortalTarget={document.body}
                          />
                          {debitError && (
                            <p className="mt-1 text-xs text-red-500">
                              {debitError.message}
                            </p>
                          )}
                          {inputErrors.debitAccount && (
                            <div className="mt-1 text-red-600 text-sm">
                              {t(inputErrors.debitAccount)}
                            </div>
                          )}
                        </div>
                        <div>
                          <FormLabel
                            htmlFor="creditAccount"
                            label={t(
                              transactionType?.creditLabel || "Credit Account"
                            )}
                            required
                          />
                          <Select
                            name="creditAccount"
                            className="mt-1 text-sm"
                            classNamePrefix="select2-selection"
                            options={credits
                              .slice()
                              .sort(sortAccountCode)
                              .map((obj) => ({
                                value: obj.id,
                                label: `${obj.code} - ${obj.name}`,
                              }))}
                            value={creditAccount}
                            onChange={setCreditAccount}
                            placeholder={t("Choose Credit Account")}
                            isDisabled={
                              !transactionType ||
                              creditLoading ||
                              transaction?.payments?.items?.length > 0
                            }
                            isLoading={creditLoading}
                            menuPortalTarget={document.body}
                          />
                          {creditError && (
                            <p className="mt-1 text-xs text-red-500">
                              {creditError.message}
                            </p>
                          )}
                          {inputErrors.creditAccount && (
                            <div className="mt-1 text-red-600 text-sm">
                              {t(inputErrors.creditAccount)}
                            </div>
                          )}
                        </div>
                      </>
                    )}

                  {!["OTHER"].includes(transactionType?.value) && (
                    <div>
                      <FormLabel htmlFor="total" label={t("Total")} required />
                      <NumericFormat
                        type="text"
                        name="total"
                        id="total"
                        value={total.value || ""}
                        placeholder={t("Enter Total Transaction")}
                        thousandSeparator="."
                        decimalSeparator=","
                        displayType="input"
                        prefix={"Rp"}
                        onValueChange={(value) => settotal(value)}
                        className="mt-1 block w-full text-sm rounded-md shadow-sm border-gray-300 focus:border-blue-500 focus:ring-blue-500"
                      />
                      {inputErrors.total && (
                        <div className="mt-1 text-red-600 text-sm">
                          {t(inputErrors.total)}
                        </div>
                      )}
                    </div>
                  )}
                  <div>
                    <FormLabel htmlFor="date" label={t("Date")} required />
                    <ReactDatePicker
                      name="data"
                      className="mt-1 block w-full text-sm rounded-md shadow-sm border-gray-300 focus:border-blue-500 focus:ring-blue-500"
                      selected={date}
                      onChange={setdate}
                      placeholderText={t("Select Date")}
                      dateFormat="dd/MM/yyyy HH:mm"
                      showTimeInput
                      timeInputLabel={t("Time")}
                      minDate={periodMinDate}
                      // A typed closed date is kept so the hint below names the period;
                      // the picker alone would drop it silently.
                      onChangeRaw={(event) => {
                        const typed = parseTypedClosedDate(
                          event?.target?.value,
                          "dd/MM/yyyy HH:mm",
                          isDateClosed,
                        );
                        if (typed) setdate(typed);
                      }}
                    />
                    {/* Says why days are greyed out — a constraint has to be
                        legible, not only enforced. */}
                    {periodClosed && (
                      <p className="mt-1 text-xs text-amber-700">
                        {isDateClosed(date)
                          ? t("accounting.period.hints.dateLocked", {
                              date: closedThroughLabel,
                            })
                          : t("accounting.period.banner.closedThrough", {
                              date: closedThroughLabel,
                            })}
                      </p>
                    )}
                    {inputErrors.date && (
                      <div className="mt-1 text-red-600 text-sm">
                        {t(inputErrors.date)}
                      </div>
                    )}
                  </div>
                  <div>
                    <FormLabel htmlFor="description" label={t("Note")} />
                    <input
                      type="text"
                      name="description"
                      value={description || ""}
                      placeholder={t("Enter Transaction Note")}
                      onChange={(e) => setdescription(e.target.value)}
                      className="mt-1 block w-full text-sm rounded-md shadow-sm border-gray-300 focus:border-blue-500 focus:ring-blue-500"
                    />
                  </div>
                  {!paymentTransactionTypes.includes(transaction.type) &&
                    ["OTHER"].includes(transactionType?.value) && (
                      <JournalEntryTable
                        accountItems={accountItems}
                        setaccountItems={setaccountItems}
                        accounts={accounts}
                        debitError={debitError}
                        allAccountLoading={allAccountLoading}
                        inputErrors={inputErrors}
                        isFormSubmit={isFormSubmit}
                        updateAccountItem={updateAccountItem}
                        handleRemoveRow={handleRemoveRow}
                        handleAddRow={handleAddRow}
                        selectedBusiness={selectedBusiness}
                        businessIdParam={businessIdParam}
                        accountingDispatch={accountingDispatch}
                        requestListAccount={requestListAccount}
                        accountItemsError={accountItemsError}
                      />
                    )}
                  {[
                    "INCOME",
                    "EXPENSE",
                    "INCOME_RECEIVABLE",
                    "EXPENSE_PAYABLE",
                    "PAYABLE",
                    "RECEIVABLE",
                  ].includes(transactionType?.value) && (
                    <>
                      {[
                        "INCOME_RECEIVABLE",
                        "EXPENSE_PAYABLE",
                        "PAYABLE",
                        "RECEIVABLE",
                      ].includes(transactionType?.value) || !paid ? (
                        <div>
                          <div className="flex justify-between">
                            <FormLabel
                              htmlFor="due-date"
                              label={t("Due Date")}
                            />
                            {Boolean(dueDate) && (
                              <button
                                type="button"
                                onClick={() => setdueDate(null)}
                                className="block text-sm font-medium text-blue-600"
                              >
                                {t("Reset")}
                              </button>
                            )}
                          </div>
                          <ReactDatePicker
                            name="due-date"
                            className="mt-1 block w-full text-sm rounded-md shadow-sm border-gray-300 focus:border-blue-500 focus:ring-blue-500"
                            selected={dueDate}
                            onChange={setdueDate}
                            placeholderText={t("Select Due Date")}
                            dateFormat="dd/MM/yyyy"
                          />
                          {inputErrors.dueDate && (
                            <div className="mt-1 text-red-600 text-sm">
                              {t(inputErrors.dueDate)}
                            </div>
                          )}
                        </div>
                      ) : null}

                      {businessPartnerError ? (
                        renderPartnerError(businessPartnerError)
                      ) : (
                        <div>
                          <div className="flex justify-between">
                            <FormLabel
                              htmlFor="partner"
                              label={t("Partner or Customer")}
                              required={
                                !paid ||
                                (paid &&
                                  !["INCOME", "EXPENSE"].includes(
                                    transactionType.value
                                  ))
                              }
                            />
                            {(transaction?.payments?.items?.length === 0 ||
                              businessIdParam) && (
                              <button
                                type="button"
                                onClick={() => setshowPartnerModal(true)}
                                className="text-sm font-medium text-blue-600"
                              >
                                {t("Add Partner")}
                              </button>
                            )}
                          </div>
                          <Select
                            id="partner"
                            className="mt-1 text-sm"
                            classNamePrefix="select2-selection"
                            isLoading={businessPartnerLoading}
                            isDisabled={
                              transaction?.payments?.items?.length > 0 ||
                              businessPartnerLoading
                            }
                            options={businessPartners.map((item) => ({
                              value: item.id,
                              label: item.name,
                            }))}
                            value={selectedPartner}
                            onChange={(selectedOption) => {
                              setselectedPartner(selectedOption);
                            }}
                            placeholder={t("Select Partner or Customer")}
                            maxMenuHeight={150}
                            menuPortalTarget={document.body}
                            isClearable
                          />
                          {inputErrors.selectedPartner && (
                            <div className="mt-1 text-red-600 text-sm">
                              {t(inputErrors.selectedPartner)}
                            </div>
                          )}
                        </div>
                      )}
                    </>
                  )}
                  {["INCOME", "EXPENSE"].includes(transactionType?.value) &&
                    paid &&
                    !transactionIdParam && (
                      <div>
                        <label
                          htmlFor="accounting-sync-enabled"
                          className="block text-sm font-medium text-gray-700"
                        >
                          {t("Sync")}
                        </label>
                        <Field
                          as="div"
                          className="flex items-center mt-1 py-2 px-3 border border-gray-300 rounded-md"
                        >
                          <Switch
                            checked={cashbookSync}
                            onChange={setcashbookSync}
                            className={classNames(
                              cashbookSync ? "bg-blue-600" : "bg-gray-200",
                              "relative inline-flex flex-shrink-0 h-6 w-11 border-2 border-transparent rounded-full cursor-pointer transition-colors ease-in-out duration-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
                            )}
                          >
                            <span className="sr-only">Use setting</span>
                            <span
                              className={classNames(
                                cashbookSync
                                  ? "translate-x-5"
                                  : "translate-x-0",
                                "pointer-events-none relative inline-block h-5 w-5 rounded-full bg-white shadow transform ring-0 transition ease-in-out duration-200"
                              )}
                            >
                              <span
                                className={classNames(
                                  cashbookSync
                                    ? "opacity-0 ease-out duration-100"
                                    : "opacity-100 ease-in duration-200",
                                  "absolute inset-0 h-full w-full flex items-center justify-center transition-opacity"
                                )}
                                aria-hidden="true"
                              >
                                <svg
                                  className="h-3 w-3 text-gray-400"
                                  fill="none"
                                  viewBox="0 0 12 12"
                                >
                                  <path
                                    d="M4 8l2-2m0 0l2-2M6 6L4 4m2 2l2 2"
                                    stroke="currentColor"
                                    strokeWidth={2}
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                  />
                                </svg>
                              </span>
                              <span
                                className={classNames(
                                  cashbookSync
                                    ? "opacity-100 ease-in duration-200"
                                    : "opacity-0 ease-out duration-100",
                                  "absolute inset-0 h-full w-full flex items-center justify-center transition-opacity"
                                )}
                                aria-hidden="true"
                              >
                                <svg
                                  className="h-3 w-3 text-blue-600"
                                  fill="currentColor"
                                  viewBox="0 0 12 12"
                                >
                                  <path d="M3.707 5.293a1 1 0 00-1.414 1.414l1.414-1.414zM5 8l-.707.707a1 1 0 001.414 0L5 8zm4.707-3.293a1 1 0 00-1.414-1.414l1.414 1.414zm-7.414 2l2 2 1.414-1.414-2-2-1.414 1.414zm3.414 2l4-4-1.414-1.414-4 4 1.414 1.414z" />
                                </svg>
                              </span>
                            </span>
                          </Switch>
                          <Label as="span" className="ml-3">
                            <div>
                              <span className="text-sm text-gray-900">
                                {t("Sync to Cashbook")}
                              </span>
                            </div>
                          </Label>
                        </Field>
                      </div>
                    )}
                </div>
              </div>
              <div className="flex flex-col sm:flex-row gap-4 justify-between bg-gray-50 rounded-b-md sm:rounded-b-lg px-4 py-6 text-right sm:px-6">
                <div className="flex flex-col sm:flex-row gap-4">
                  <Button
                    outline
                    type="button"
                    disabled={submitLoading && !showPaymentModal}
                    className="w-full sm:w-auto"
                    title={t("Manage Accounting Accounts")}
                    onClick={() => navigate(`/account?id=${businessIdParam}`)}
                  />
                  <Button
                    outline
                    type="button"
                    disabled={submitLoading && !showPaymentModal}
                    className="w-full sm:w-auto"
                    title={t("Manage Partners")}
                    onClick={() => {
                      navigate(`/partner?id=${selectedBusiness?.id}`);
                    }}
                  />
                </div>
                <div className="flex flex-col sm:flex-row gap-4">
                  {transactionIdParam &&
                    [
                      "RECEIVABLE",
                      "PAYABLE",
                      "INCOME_RECEIVABLE",
                      "EXPENSE_PAYABLE",
                    ].includes(transactionType?.value) && (
                      <Button
                        type="button"
                        className="w-full sm:w-auto"
                        disabled={
                          (submitLoading && !showPaymentModal) ||
                          transaction.paid
                        }
                        title={
                          transaction.paid
                            ? t("Paid")
                            : receivableTransactionTypes.includes(
                                transactionType?.value
                              )
                            ? t("Pay Receivable")
                            : t("Pay Payable")
                        }
                        onClick={() => setshowPaymentModal(true)}
                        outline
                      />
                    )}
                  {paymentTransactionTypes.includes(transaction.type) ? (
                    <Button
                      type="submit"
                      className="w-full sm:w-auto"
                      title={t("Save")}
                      loading={submitLoading || businessLoading}
                      disabled={
                        submitLoading ||
                        businessLoading ||
                        isDateClosed(paymentDate) ||
                        isBusinessWriteBlocked(selectedBusiness)
                      }
                      onClick={(e) => {
                        e.preventDefault();
                        handlePayment(true);
                      }}
                    />
                  ) : (
                    <Button
                      type="submit"
                      className="w-full sm:w-auto"
                      title={
                        transactionIdParam
                          ? t("Save")
                          : newTransactionError
                          ? t("Sync to Cashbook")
                          : t("Create")
                      }
                      loading={
                        (submitLoading ||
                          businessLoading ||
                          newTransactionLoading) &&
                        !showPaymentModal
                      }
                      disabled={
                        ((submitLoading ||
                          businessLoading ||
                          newTransactionLoading ||
                          businesses.length === 0) &&
                          !showPaymentModal) ||
                        isDateClosed(date) ||
                        isBusinessWriteBlocked(selectedBusiness)
                      }
                      onClick={(e) => {
                        e.preventDefault();
                        transactionIdParam
                          ? onSave(true)
                          : newTransactionError
                          ? onCashbookSync()
                          : onSave();
                      }}
                    />
                  )}
                </div>
              </div>
            </form>
          </div>
          {transactionIdParam &&
            transaction?.payments?.items?.length > 0 &&
            [
              "RECEIVABLE",
              "PAYABLE",
              "INCOME_RECEIVABLE",
              "EXPENSE_PAYABLE",
            ].includes(transactionType?.value) && (
              <div className="flex flex-col">
                <div className="overflow-x-auto -mx-4 sm:-mx-6 lg:-mx-8">
                  <div className="inline-block min-w-full align-middle md:px-6 lg:px-8">
                    <div className="overflow-hidden border border-gray-200 rounded-lg shadow-sm">
                      <table className="min-w-full divide-y divide-gray-300">
                        <thead className="bg-gray-50">
                          <tr>
                            <th className="px-4 py-2 font-medium text-sm text-left text-gray-900 whitespace-nowrap">
                              {t("Date")}
                            </th>
                            <th className="px-4 py-2 font-medium text-sm text-left text-gray-900 whitespace-nowrap">
                              {t("Note")}
                            </th>
                            <th className="px-4 py-2 font-medium text-sm text-left text-gray-900 whitespace-nowrap">
                              {t("Type")}
                            </th>
                            <th className="px-4 py-2 font-medium text-sm text-left text-gray-900 whitespace-nowrap">
                              {t("Total")}
                            </th>
                            <th className="px-4 py-2 font-medium text-sm text-left text-gray-900 whitespace-nowrap">
                              {t("Action")}
                            </th>
                          </tr>
                        </thead>
                        <tbody className="divide-y divide-gray-200 bg-white">
                          {selectedBusiness &&
                          transaction?.payments?.items?.length > 0 ? (
                            transaction.payments.items.map((item) => {
                              return (
                                <tr key={item.id}>
                                  <th className="px-4 py-2 font-medium text-sm text-gray-700 whitespace-nowrap ">
                                    {dayjs(item.createdAt)
                                      .locale(i18n.language)
                                      .format("DD MMM YYYY")}
                                  </th>
                                  <td className="px-4 py-2 text-sm text-gray-700 whitespace-nowrap ">
                                    {item.description}
                                  </td>
                                  <td className="px-4 py-2 text-sm text-left text-gray-700 whitespace-nowrap">
                                    {t(convertToTitleCase(item.type))}
                                  </td>
                                  <td className="px-4 py-2 text-sm text-left text-gray-700 whitespace-nowrap">
                                    <NumericFormat
                                      displayType={"text"}
                                      value={item.total}
                                      thousandSeparator={"."}
                                      decimalSeparator={","}
                                      prefix={"Rp"}
                                    />
                                  </td>
                                  <td className="px-4 py-2 text-sm text-left text-gray-700 whitespace-nowrap">
                                    <div className="flex flex-auto gap-2">
                                      <button
                                        onClick={() =>
                                          navigate(
                                            `/accounting-transaction/create?id=${item.id}`
                                          )
                                        }
                                      >
                                        <PencilAltIcon className="h-5 w-5 text-blue-500" />
                                      </button>
                                      <button
                                        onClick={() => {
                                          setshowConfirmModal(true);
                                          setpaidTransactionID(item.id);
                                        }}
                                      >
                                        <TrashIcon className="h-5 w-5 text-red-500" />
                                      </button>
                                    </div>
                                  </td>
                                </tr>
                              );
                            })
                          ) : (
                            <ErrorStateTable error={error} />
                          )}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            )}
        </div>
      </div>
    );
  }
  return <EmptyBusiness loading={businessLoading} />;
};
